/* tslint:disable */
/* eslint-disable */
/**
 * Commerce Webservices
 * Manages all of the common commerce functionality, and also includes customizations from installed AddOns. The implementing extension is called commercewebservices.
 *
 * The version of the OpenAPI document: 2.2.1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import type {
  ErrorList,
  GetOrgUnits200Response,
  OrgUserRegistrationData,
  User,
  UserDefaultOrgUnit,
} from '../models';
import {
    ErrorListFromJSON,
    ErrorListToJSON,
    GetOrgUnits200ResponseFromJSON,
    GetOrgUnits200ResponseToJSON,
    OrgUserRegistrationDataFromJSON,
    OrgUserRegistrationDataToJSON,
    UserFromJSON,
    UserToJSON,
    UserDefaultOrgUnitFromJSON,
    UserDefaultOrgUnitToJSON,
} from '../models';

export interface CreateRegistrationRequestRequest {
    baseSiteId: string;
    orgUserRegistrationData: OrgUserRegistrationData;
    fields?: string;
    sapCommerceCloudCaptchaToken?: string;
    sapCommerceCloudCustomerId?: string;
}

export interface GetOrgUnitsRequest {
    baseSiteId: string;
    userId: string;
    fields?: string;
    sapCommerceCloudCustomerId?: string;
}

export interface GetOrgUserRequest {
    baseSiteId: string;
    userId: string;
    fields?: string;
    sapCommerceCloudCustomerId?: string;
}

export interface SetOrgCustomerDefaultOrgUnitRequest {
    baseSiteId: string;
    userId: string;
    userDefaultOrgUnit: UserDefaultOrgUnit;
    sapCommerceCloudCustomerId?: string;
}

/**
 * B2BUsersApi - interface
 * 
 * @export
 * @interface B2BUsersApiInterface
 */
export interface B2BUsersApiInterface {
    /**
     * Registers a B2B customer. Requires the following parameters: titleCode, firstName, lastName, email, message, verificationTokenId, verificationTokenCode. Only when OTP for registration is enabled, verificationTokenId and verificationTokenCode are required.
     * @summary Creates a registration request for a B2B customer.
     * @param {string} baseSiteId Base site identifier
     * @param {OrgUserRegistrationData} orgUserRegistrationData 
     * @param {string} [fields] Response configuration. This is the list of fields that should be returned in the response body. Examples: BASIC,DEFAULT,FULL
     * @param {string} [sapCommerceCloudCaptchaToken] The user\&#39;s response token returned by captcha provider. When the captchaCheckEnabled &#x3D; true for the store, the field is mandatory and will call the provider to validate.
     * @param {string} [sapCommerceCloudCustomerId] Default B2B Unit of the B2B customer to be used during the request.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof B2BUsersApiInterface
     */
    createRegistrationRequestRaw(requestParameters: CreateRegistrationRequestRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>>;

    /**
     * Registers a B2B customer. Requires the following parameters: titleCode, firstName, lastName, email, message, verificationTokenId, verificationTokenCode. Only when OTP for registration is enabled, verificationTokenId and verificationTokenCode are required.
     * Creates a registration request for a B2B customer.
     */
    createRegistrationRequest(requestParameters: CreateRegistrationRequestRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void>;

    /**
     * Provides a list of organizational units that the currently authenticated B2B customer has access to.
     * @summary Retrieves organizational units assigned to the current B2B customer.
     * @param {string} baseSiteId Base site identifier
     * @param {string} userId User identifier or one of the literals : \&#39;current\&#39; for currently authenticated user, \&#39;anonymous\&#39; for anonymous user
     * @param {string} [fields] Response configuration. This is the list of fields that should be returned in the response body. Examples: BASIC,DEFAULT,FULL
     * @param {string} [sapCommerceCloudCustomerId] Default B2B Unit of the B2B customer to be used during the request.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof B2BUsersApiInterface
     */
    getOrgUnitsRaw(requestParameters: GetOrgUnitsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<GetOrgUnits200Response>>;

    /**
     * Provides a list of organizational units that the currently authenticated B2B customer has access to.
     * Retrieves organizational units assigned to the current B2B customer.
     */
    getOrgUnits(requestParameters: GetOrgUnitsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<GetOrgUnits200Response>;

    /**
     * 
     * @summary Retrieves a B2B customer profile.
     * @param {string} baseSiteId Base site identifier
     * @param {string} userId User identifier or one of the literals : \&#39;current\&#39; for currently authenticated user, \&#39;anonymous\&#39; for anonymous user
     * @param {string} [fields] Response configuration. This is the list of fields that should be returned in the response body. Examples: BASIC,DEFAULT,FULL
     * @param {string} [sapCommerceCloudCustomerId] Default B2B Unit of the B2B customer to be used during the request.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof B2BUsersApiInterface
     */
    getOrgUserRaw(requestParameters: GetOrgUserRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<User>>;

    /**
     * Retrieves a B2B customer profile.
     */
    getOrgUser(requestParameters: GetOrgUserRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<User>;

    /**
     * Sets the required default organizational unit for a B2B customer.
     * @summary Sets the default organizational unit.
     * @param {string} baseSiteId Base site identifier
     * @param {string} userId User identifier or one of the literals : \&#39;current\&#39; for currently authenticated user, \&#39;anonymous\&#39; for anonymous user
     * @param {UserDefaultOrgUnit} userDefaultOrgUnit 
     * @param {string} [sapCommerceCloudCustomerId] Default B2B Unit of the B2B customer to be used during the request.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof B2BUsersApiInterface
     */
    setOrgCustomerDefaultOrgUnitRaw(requestParameters: SetOrgCustomerDefaultOrgUnitRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>>;

    /**
     * Sets the required default organizational unit for a B2B customer.
     * Sets the default organizational unit.
     */
    setOrgCustomerDefaultOrgUnit(requestParameters: SetOrgCustomerDefaultOrgUnitRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void>;

}

/**
 * 
 */
export class B2BUsersApi extends runtime.BaseAPI implements B2BUsersApiInterface {

    /**
     * Registers a B2B customer. Requires the following parameters: titleCode, firstName, lastName, email, message, verificationTokenId, verificationTokenCode. Only when OTP for registration is enabled, verificationTokenId and verificationTokenCode are required.
     * Creates a registration request for a B2B customer.
     */
    async createRegistrationRequestRaw(requestParameters: CreateRegistrationRequestRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters.baseSiteId === null || requestParameters.baseSiteId === undefined) {
            throw new runtime.RequiredError('baseSiteId','Required parameter requestParameters.baseSiteId was null or undefined when calling createRegistrationRequest.');
        }

        if (requestParameters.orgUserRegistrationData === null || requestParameters.orgUserRegistrationData === undefined) {
            throw new runtime.RequiredError('orgUserRegistrationData','Required parameter requestParameters.orgUserRegistrationData was null or undefined when calling createRegistrationRequest.');
        }

        const queryParameters: any = {};

        if (requestParameters.fields !== undefined) {
            queryParameters['fields'] = requestParameters.fields;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (requestParameters.sapCommerceCloudCaptchaToken !== undefined && requestParameters.sapCommerceCloudCaptchaToken !== null) {
            headerParameters['sap-commerce-cloud-captcha-token'] = String(requestParameters.sapCommerceCloudCaptchaToken);
        }

        if (requestParameters.sapCommerceCloudCustomerId !== undefined && requestParameters.sapCommerceCloudCustomerId !== null) {
            headerParameters['sap-commerce-cloud-customer-id'] = String(requestParameters.sapCommerceCloudCustomerId);
        }

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("oauth2_authorization_code", ["basic"]);
        }

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("oauth2_client_credentials", ["extended"]);
        }

        const response = await this.request({
            path: `/{baseSiteId}/orgUsers`.replace(`{${"baseSiteId"}}`, encodeURIComponent(String(requestParameters.baseSiteId))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: OrgUserRegistrationDataToJSON(requestParameters.orgUserRegistrationData),
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Registers a B2B customer. Requires the following parameters: titleCode, firstName, lastName, email, message, verificationTokenId, verificationTokenCode. Only when OTP for registration is enabled, verificationTokenId and verificationTokenCode are required.
     * Creates a registration request for a B2B customer.
     */
    async createRegistrationRequest(requestParameters: CreateRegistrationRequestRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.createRegistrationRequestRaw(requestParameters, initOverrides);
    }

    /**
     * Provides a list of organizational units that the currently authenticated B2B customer has access to.
     * Retrieves organizational units assigned to the current B2B customer.
     */
    async getOrgUnitsRaw(requestParameters: GetOrgUnitsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<GetOrgUnits200Response>> {
        if (requestParameters.baseSiteId === null || requestParameters.baseSiteId === undefined) {
            throw new runtime.RequiredError('baseSiteId','Required parameter requestParameters.baseSiteId was null or undefined when calling getOrgUnits.');
        }

        if (requestParameters.userId === null || requestParameters.userId === undefined) {
            throw new runtime.RequiredError('userId','Required parameter requestParameters.userId was null or undefined when calling getOrgUnits.');
        }

        const queryParameters: any = {};

        if (requestParameters.fields !== undefined) {
            queryParameters['fields'] = requestParameters.fields;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (requestParameters.sapCommerceCloudCustomerId !== undefined && requestParameters.sapCommerceCloudCustomerId !== null) {
            headerParameters['sap-commerce-cloud-customer-id'] = String(requestParameters.sapCommerceCloudCustomerId);
        }

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("oauth2_authorization_code", ["basic"]);
        }

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("oauth2_client_credentials", ["extended"]);
        }

        const response = await this.request({
            path: `/{baseSiteId}/orgUsers/{userId}/orgUnits`.replace(`{${"baseSiteId"}}`, encodeURIComponent(String(requestParameters.baseSiteId))).replace(`{${"userId"}}`, encodeURIComponent(String(requestParameters.userId))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => GetOrgUnits200ResponseFromJSON(jsonValue));
    }

    /**
     * Provides a list of organizational units that the currently authenticated B2B customer has access to.
     * Retrieves organizational units assigned to the current B2B customer.
     */
    async getOrgUnits(requestParameters: GetOrgUnitsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<GetOrgUnits200Response> {
        const response = await this.getOrgUnitsRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Retrieves a B2B customer profile.
     */
    async getOrgUserRaw(requestParameters: GetOrgUserRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<User>> {
        if (requestParameters.baseSiteId === null || requestParameters.baseSiteId === undefined) {
            throw new runtime.RequiredError('baseSiteId','Required parameter requestParameters.baseSiteId was null or undefined when calling getOrgUser.');
        }

        if (requestParameters.userId === null || requestParameters.userId === undefined) {
            throw new runtime.RequiredError('userId','Required parameter requestParameters.userId was null or undefined when calling getOrgUser.');
        }

        const queryParameters: any = {};

        if (requestParameters.fields !== undefined) {
            queryParameters['fields'] = requestParameters.fields;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (requestParameters.sapCommerceCloudCustomerId !== undefined && requestParameters.sapCommerceCloudCustomerId !== null) {
            headerParameters['sap-commerce-cloud-customer-id'] = String(requestParameters.sapCommerceCloudCustomerId);
        }

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("oauth2_authorization_code", ["basic"]);
        }

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("oauth2_client_credentials", ["extended"]);
        }

        const response = await this.request({
            path: `/{baseSiteId}/orgUsers/{userId}`.replace(`{${"baseSiteId"}}`, encodeURIComponent(String(requestParameters.baseSiteId))).replace(`{${"userId"}}`, encodeURIComponent(String(requestParameters.userId))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => UserFromJSON(jsonValue));
    }

    /**
     * Retrieves a B2B customer profile.
     */
    async getOrgUser(requestParameters: GetOrgUserRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<User> {
        const response = await this.getOrgUserRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Sets the required default organizational unit for a B2B customer.
     * Sets the default organizational unit.
     */
    async setOrgCustomerDefaultOrgUnitRaw(requestParameters: SetOrgCustomerDefaultOrgUnitRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters.baseSiteId === null || requestParameters.baseSiteId === undefined) {
            throw new runtime.RequiredError('baseSiteId','Required parameter requestParameters.baseSiteId was null or undefined when calling setOrgCustomerDefaultOrgUnit.');
        }

        if (requestParameters.userId === null || requestParameters.userId === undefined) {
            throw new runtime.RequiredError('userId','Required parameter requestParameters.userId was null or undefined when calling setOrgCustomerDefaultOrgUnit.');
        }

        if (requestParameters.userDefaultOrgUnit === null || requestParameters.userDefaultOrgUnit === undefined) {
            throw new runtime.RequiredError('userDefaultOrgUnit','Required parameter requestParameters.userDefaultOrgUnit was null or undefined when calling setOrgCustomerDefaultOrgUnit.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (requestParameters.sapCommerceCloudCustomerId !== undefined && requestParameters.sapCommerceCloudCustomerId !== null) {
            headerParameters['sap-commerce-cloud-customer-id'] = String(requestParameters.sapCommerceCloudCustomerId);
        }

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("oauth2_authorization_code", ["basic"]);
        }

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("oauth2_client_credentials", ["extended"]);
        }

        const response = await this.request({
            path: `/{baseSiteId}/orgUsers/{userId}/defaultOrgUnit`.replace(`{${"baseSiteId"}}`, encodeURIComponent(String(requestParameters.baseSiteId))).replace(`{${"userId"}}`, encodeURIComponent(String(requestParameters.userId))),
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: UserDefaultOrgUnitToJSON(requestParameters.userDefaultOrgUnit),
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Sets the required default organizational unit for a B2B customer.
     * Sets the default organizational unit.
     */
    async setOrgCustomerDefaultOrgUnit(requestParameters: SetOrgCustomerDefaultOrgUnitRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.setOrgCustomerDefaultOrgUnitRaw(requestParameters, initOverrides);
    }

}
